import type React from 'react';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { SetPageStateValue } from 'src/shared/pageState';

import { useFocusFallbackRef } from 'src/app/shared/hooks/focus';
import { useIsStarter } from 'src/app/shared/hooks/session';

import { PageBanner } from '../components/PageBanner';
import { StepBody } from '../components/StepBody';
import { StepProgressBar } from '../components/StepProgressBar';

import { useRedirectUnauthorized } from './hooks/useRedirectUnauthorized';
import { useTrackLoginOrJoinMethod } from './hooks/useTrackLoginOrJoinMethod';
import { useTrackSapView } from './hooks/useTrackSapView';

export const StartAPetitionLayout: React.FC = () => {
	useTrackLoginOrJoinMethod();
	useTrackSapView();
	useRedirectUnauthorized();
	const isStarter = useIsStarter();

	const ref = useFocusFallbackRef(
		({ container, focus }) =>
			focus(container.querySelector('#prepublish-container')) || focus(container.querySelector('h1')),
	);

	return (
		<DesignSystemLegacy theme={sunriseTheme}>
			{/* Height is calculated by subtracting the heading height from 100vh.
				This allows the page content to fill the full height for elements that have a solid background color */}
			<Flex
				sx={{
					flexDirection: 'column',
					color: 'sunrise.semantic.typography.strong',
					height: 'calc(100vh - 61px)',
				}}
				ref={ref}
			>
				<SetPageStateValue name="sapPageState" value={{ isStarter }} />
				<StepProgressBar />

				<PageBanner />
				<StepBody />
				{/* This component preserves the space for the mobile navigation button so that other
			components would not be presented behind the fixed navigation buttons on the bottom of the screen. */}
				<Box sx={{ display: ['block', 'none'], minHeight: 77 }} />
			</Flex>
		</DesignSystemLegacy>
	);
};
